export default {
  subTitle: 'Statistics',
  title: 'General',
}